import { render, staticRenderFns } from "./CollapseMenu.vue?vue&type=template&id=12fce65e&scoped=true"
import script from "./CollapseMenu.vue?vue&type=script&lang=js"
export * from "./CollapseMenu.vue?vue&type=script&lang=js"
import style0 from "./CollapseMenu.vue?vue&type=style&index=0&id=12fce65e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fce65e",
  null
  
)

export default component.exports